import { render, staticRenderFns } from "./SectionFactorUse.vue?vue&type=template&id=65755255"
import script from "./SectionFactorUse.vue?vue&type=script&lang=ts"
export * from "./SectionFactorUse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports